//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import VueMarkdown from 'vue-markdown';
export default {
  components: {
          VueMarkdown
      },
  data() {
    return {
      inputMessage: "",
      list: [],
      status: true,
      host:'https://ds.uunbiot.com:61888',
    };
  },
  created(){
      if(this.$func.getLocal('ds_list')){
          this.list = JSON.parse(this.$func.getLocal('ds_list'));
      }
  },  
  methods: {
    async fetchResponse() {
      if (!this.inputMessage.trim()) return;
      this.$func.startLoading('思考中。。。');
      this.list.push({sender:0,content:this.inputMessage});
      try {
        const response = await axios.post(this.host+"/api/generate", {
          model: "deepseek-r1:32b",
          //model: "deepseek-r1:7b",
          // format: "json",
          stream: false,
          prompt: this.inputMessage,
        },
      );
        // 处理返回的数据
        const data = response.data;
        console.log('response',response);
        if (data && data.response) {
          this.list.push({sender:1,content:response.data.response,created_at:this.$func.dateTime()});
          // const result = JSON.parse(data.response);
          // console.log('result',result);
          // let responseData;
          // if(result.messages && result.messages.length > 0){
          //     result.messages.forEach((item) => {
          //         if(item.role != 'user'){
          //             responseData = item.content;
          //         }
          //     });
          //     // responseData = result.messages[0].content;
          // }else{
          //     responseData = result.answer || result.content || result.description || result.response || result.context;
          // }
          // if(responseData){
          //     this.list.push({sender:1,content:responseData,created_at:createdAt});
          // }else{
          //     this.list.push({sender:1,content:'网络错误，请稍后再试'});
          // }
          this.inputMessage = '';
          this.$func.setLocal('ds_list',JSON.stringify(this.list));
        }
      } catch (error) {
          this.list.push({sender:1,content:'网络错误，请稍后再试'});
      }
      this.$func.endLoading();
    },
    cleanList(){
      this.$func.confirm('确认清理历史记录？','提示',()=>{
          this.list = [];
          this.$func.setLocal('ds_list','');
      })
    }
  },
};



// WEBPACK FOOTER //
// ./src/pages/dsService.vue